<script setup lang="ts">
import { useQuery } from '@urql/vue';
import { type PartnerReview, Review, ReviewList } from '@/features/reviews';
import { graphql } from '@/gql';

const props = defineProps<{
  masterId: number;
}>();

const { data: queryData, fetching } = useQuery({
  query: graphql(/* GraphQL */ `
    query MasterReviewsTab_MasterQuery($id: Int!) {
      master(id: $id) {
        id
        reviews {
          id
          createdAt
          text
          rating
          client {
            id
            fullName
          }
          attachedPhotos {
            id
            url
          }
        }
      }
    }
  `),
  variables: toRef(() => ({
    id: props.masterId,
  })),
});
const reviews = toRef(() =>
  queryData.value?.master.reviews.map<PartnerReview>((review) => ({
    photoUrls: [],
    ...review,
  }))
);
</script>

<template>
  <AppLoader v-if="fetching" />
  <div v-else-if="reviews?.length">
    <Review
      v-for="review in reviews"
      :key="review.id"
      class="page-card p-6"
      :review="review"
    />
    <AppObserver />
  </div>
  <div v-else class="text-center text-black-secondary">
    У мастера пока нет ни одного отзыва
  </div>
</template>
